import * as React from 'react';
import * as styles from './button_group.css';
import { mergeStyles } from '@cian/utils/lib/shared/style';

interface IProps {
  block?: boolean;
  options: IOption[];
  value: string | number;
  onClick(value: any): void;
}

export interface IOption {
  value: string;
  label: string | number;
}

export function ButtonGroup({ block, options, value, onClick }: IProps) {
  return (
    <div {...mergeStyles(block && styles['block'])}>
      {options.map((option: IOption, index) => (
        <button
          key={index}
          {...mergeStyles(styles['button'], value === option.value && styles['selected'])}
          onClick={() => onClick(option.value)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
